export const CODE_EDITOR_FEEDBACK_URL: string =
  "https://form.raspberrypi.org/f/code-editor-feedback";

export const CODE_CLASSROOM_FEEDBACK_URL: string =
  "https://form.raspberrypi.org/4873801";
